import React from 'react';
import { motion } from 'framer-motion';

const ServiceCard = ({ icon, title, description, image }) => {
  return (
    <motion.div
      className="card card-hover h-full"
      whileHover={{ 
        scale: 1.03, 
        boxShadow: '0 10px 30px -5px rgba(0, 0, 0, 0.15)' 
      }}
      transition={{ duration: 0.3 }}
    >
      <div className="h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-110"
        />
      </div>
      <div className="p-6">
        <div className="text-accent-600 mb-4">
          {icon}
        </div>
        <h3 className="text-xl font-bold text-primary-700 mb-2">{title}</h3>
        <p className="text-neutral-600">{description}</p>
      </div>
    </motion.div>
  );
};

export default ServiceCard;